/**
 * 弹窗触发事件类型枚举
 * 用于标识不同类型的弹窗/订阅工具
 */
export enum TriggerEventType {
  /** 新用户订阅弹窗 */
  NEW_USER_SUBSCRIBE = 0,
  /** 退出意图挽留弹窗 */
  EXIT_INTENT = 1,
  /** 新用户加购订阅弹窗 */
  ADD_TO_CART = 2,
  /** 邮件/短信承接弹窗 */
  COUPON_LINK = 3,
  /** 老用户召回弹窗 */
  RETURNING_USER = 4,
  /** 弃单挽留弹窗 */
  ABANDON_CHECKOUT = 5,
  /** 到货提醒弹窗 */
  BACK_IN_STOCK = 6,
  /** 嵌入式表单 */
  EMBEDDED_FORM = 7,
  /** 自定义触发表单 */
  CUSTOM_TRIGGER = 8
}

/**
 * 触发事件类型映射 - 用于显示名称
 */
export const TriggerEventTypeMap: Record<TriggerEventType, string> = {
  [TriggerEventType.NEW_USER_SUBSCRIBE]: '新用户订阅',
  [TriggerEventType.EXIT_INTENT]: '离开挽留',
  [TriggerEventType.ADD_TO_CART]: '加购订阅',
  [TriggerEventType.COUPON_LINK]: '优惠券承接',
  [TriggerEventType.RETURNING_USER]: '老用户召回',
  [TriggerEventType.ABANDON_CHECKOUT]: '弃单挽留',
  [TriggerEventType.BACK_IN_STOCK]: '到货提醒',
  [TriggerEventType.EMBEDDED_FORM]: '嵌入式表单',
  [TriggerEventType.CUSTOM_TRIGGER]: '自定义触发'
};

/**
 * 触发事件类型选项 - 用于下拉选择
 */
export const TriggerEventTypeOptions = [
  { label: '全部类型', value: null },
  { label: '新用户订阅弹窗', value: TriggerEventType.NEW_USER_SUBSCRIBE },
  { label: '退出意图挽留弹窗', value: TriggerEventType.EXIT_INTENT },
  { label: '新用户加购订阅弹窗', value: TriggerEventType.ADD_TO_CART },
  { label: '邮件/短信承接弹窗', value: TriggerEventType.COUPON_LINK },
  { label: '老用户召回弹窗', value: TriggerEventType.RETURNING_USER },
  { label: '弃单挽留弹窗', value: TriggerEventType.ABANDON_CHECKOUT },
  { label: '到货提醒弹窗', value: TriggerEventType.BACK_IN_STOCK },
  { label: '嵌入式表单', value: TriggerEventType.EMBEDDED_FORM },
  { label: '自定义触发表单', value: TriggerEventType.CUSTOM_TRIGGER }
];

/**
 * 根据触发事件类型获取显示名称
 * @param type 触发事件类型
 * @returns 显示名称
 */
export function getTriggerEventTypeName(type: TriggerEventType | number | null | undefined): string {
  if (type === null || type === undefined) {
    return '-';
  }
  return TriggerEventTypeMap[type as TriggerEventType] || '-';
}
